export default __webpack_public_path__ + "static/media/joinUs.6f8b446f.png";